import { useMemo } from "react";
import Select from "react-select";

const initialFilters = {
  type: '',
  numero: '',
  dateDebut: '',
  dateFin: '',
  idTiers: ''
}
const TransfertFilters = ({ filters = initialFilters, mode, sourceTypes, sourceTiers, errors, setFilters, onSearch }) => {

  const tierOptions = useMemo(
    () =>
      sourceTiers.map(tier => ({
        value: tier.id,
        label: tier.name
      })),
    [sourceTiers]
  );
  const handleChange = (field, value) => {
    setFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div className="card mb-4 p-4 shadow-sm">

      {/* Ligne 1 */}
      <div className="row mb-3">

        <div className="col-md-4">
          <label className="form-label fw-bold">Numéro</label>
          <input
            type="text"
            className="form-control compact-control"
            value={filters.numero || ""}
            onChange={e => handleChange("numero", e.target.value)}
          />
        </div>

        <div className="col-md-4">
          <label className="form-label fw-bold">Type document</label>
          <select
            // className="form-select compact-control w-100"
            className={`form-select compact-control w-100 ${errors?.type ? "is-invalid" : ""
              }`}
            value={filters.type || ""}
            onChange={e => handleChange("type", e.target.value)}
          >
            <option value="">-- Sélectionnez un type --</option>
            {/* <option value="DemandeAchat">Devis</option>
            <option value="BonCommandeAchat">Bon de commande</option>
            <option value="BonReception">Bon livraison</option>
            <option value="FactureAchat">Facture</option> */}
            {sourceTypes.map(t => (
              <option key={t.value} value={t.value}>
                {t.text}
              </option>
            ))}
          </select>
          {errors?.type && (
            <div className="invalid-feedback">
              {errors.type}
            </div>
          )}
        </div>
        <div className="col-md-4">
          <label className="form-label fw-bold">
            {mode === "achat" ? "Fournisseur" : "Client"}
          </label>

          <Select
            options={tierOptions}
            value={
              tierOptions.find(
                option => option.value === Number(filters.idTiers)
              ) || null
            }
            onChange={(selectedOption) =>
              handleChange(
                "idTiers",
                selectedOption ? selectedOption.value : ""
              )
            }
            placeholder={`Rechercher un ${mode === "achat" ? "fournisseur" : "client"}...`}
            isSearchable
            isClearable
            className={errors?.idTiers ? "is-invalid" : ""}
            classNamePrefix="react-select"
          />

          {errors?.idTiers && (
            <div className="invalid-feedback d-block">
              {errors.idTiers}
            </div>
          )}
        </div>
      </div>

      {/* Ligne 2 */}
      <div className="row align-items-end">

        <div className="col-md-5">
          <label className="form-label fw-bold">Date début</label>
          <input
            type="date"
            className="form-control compact-control"
            value={filters.dateDebut || ""}
            onChange={e => handleChange("dateDebut", e.target.value)}
          />
        </div>

        <div className="col-md-5">
          <label className="form-label fw-bold">Date fin</label>
          <input
            type="date"
            className="form-control compact-control"
            value={filters.dateFin || ""}
            onChange={e => handleChange("dateFin", e.target.value)}
          />
        </div>

        {/* Bouton aligné à droite */}
        <div className="col-md-2 d-flex justify-content-end">
          {/* <div className="col-md-6 d-flex justify-content-end"> */}
          <button
            className="btn btn-primary px-4"
            onClick={onSearch}
          >
            Rechercher
          </button>
          {/* </div> */}
        </div>


      </div>

    </div>
  );
};

export default TransfertFilters;